export const HTTP_API_ENDPOINTS_CONSTANTS = {
  AUTHENTICATION: {
    GET_VERIFICATION_CODE_ASYNC: 'authentication/GetVerificationCodeAsync',
    SUBMIT_VERIFICATION_CODE_ASYNC: 'authentication/SubmitVerificationCodeAsync',
    SIGN_UP_ASYNC: 'authentication/SignUpAsync',
    REFRESH_TOKEN_ASYNC: 'authentication/RefreshTokenAsync',
    GOOGLE_SSO_ASYNC: 'authentication/GoogleSsoAsync',
  },
  DASHBOARD: {
    STREAKS: 'dashboard/StreaksAsync',
    SOURCES_AND_HIGHLIGHTS_COUNTS: 'dashboard/SourcesAndHighlightsCountsAsync',
    UPCOMING_REMINDER_INFORMATION: 'dashboard/UpcomingReminderInformationAsync',
  },
  Sources: {
    GetAll: 'Sources',
    Get: 'Sources/{id}',
    GET_LOOKUP: 'Sources/getLookup',
    Create: 'Sources',
    Update: 'Sources',
    Delete: 'Sources/{id}',
    BULK_DELETE: 'Sources/bulkDelete',
    SET_STARRED: (id: string) => `Sources/${id}/star`,
  },
  Highlights: {
    GetAll: 'Highlights',
    GetBySource: 'Highlights/bySource',
    Get: 'Highlights/{id}',
    GET_LOOKUP: 'Highlights/getLookup',
    Create: 'Highlights',
    Update: 'Highlights',
    Delete: 'Highlights/{id}',
    BULK_DELETE: 'Highlights/bulkDelete',
    SET_STARRED: (id: string) => `Highlights/${id}/star`,
  },
  ReminderLogs: {
    GetAll: 'ReminderLogs',
    Get: 'ReminderLogs/{id}',
    GET_LOOKUP: 'ReminderLogs/getLookup',
    Create: 'ReminderLogs',
    Update: 'ReminderLogs',
    Delete: 'ReminderLogs/{id}',
    BULK_DELETE: 'ReminderLogs/bulkDelete',
  },
  Users: {
    GetAll: 'Users',
    Get: 'Users/{id}',
    GET_BY_USER: 'Users/GetByUser',
    GET_LOOKUP: 'Users/getLookup',
    Create: 'Users',
    Update: 'Users',
    Delete: 'Users/{id}',
    BULK_DELETE: 'Users/bulkDelete',
  },
  UserSettings: {
    GetAll: 'UserSettings',
    Get: 'UserSettings/{id}',
    GET_BY_USER: 'UserSettings/GetByUser',
    GET_LOOKUP: 'UserSettings/getLookup',
    Create: 'UserSettings',
    Update: 'UserSettings',
    Delete: 'UserSettings/{id}',
    BULK_DELETE: 'UserSettings/bulkDelete',
  },
  IMPORT: {
    IMPORT_EXCEL_ASYNC: 'Import/ImportExcelAsync',
    CONFIRM_IMPORT_EXCEL_ASYNC: 'Import/ConfirmImportExcelAsync',
    IMPORT_KINDLE_HTML_ASYNC: 'Import/ImportKindleHtmlAsync',
    CONFIRM_IMPORT_KINDLE_HTML_ASYNC: 'Import/ConfirmImportKindleHtmlAsync',
    IMPORT_APPLE_BOOK_ASYNC: 'Import/ImportAppleBookAsync',
    CONFIRM_IMPORT_APPLE_BOOK_ASYNC: 'Import/ConfirmImportAppleBookAsync'
  },
  REVIEW_SESSION: {
    GET_ALL: 'ReviewSessions',
    GET: 'ReviewSessions/{id}',
    GET_LOOKUP: 'ReviewSessions/getLookup',
    CREATE: 'ReviewSessions',
    UPDATE: 'ReviewSessions',
    DELETE: 'ReviewSessions/{id}',
    BULK_DELETE: 'ReviewSessions/bulkDelete',
    RESET_REVIEW_SESSION: 'ReviewSessions/ResetReviewSession',
  },
  REVIEW_SESSION_ITEM: {
    UPDATE: 'ReviewSessions/UpdateItem'
  },

} as const;
